import { render, staticRenderFns } from "./ProjectAssetManagerTileAsset.vue?vue&type=template&id=6b7a21a4"
import script from "./ProjectAssetManagerTileAsset.vue?vue&type=script&lang=js"
export * from "./ProjectAssetManagerTileAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports